(() => {
  'use strict';

  const openCartDrawer = (event) => {
    const trigger = event.target.closest('[data-nn-cart-open]');
    if (!trigger) return;

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      event.preventDefault();
      drawer.open();
    }
  };

  // Reliable NicheNova cart removal fallback.
  // This handles both the cart drawer and the full /cart page. It bypasses the
  // theme's failing updater, uses Shopify's Ajax Cart API as the source of
  // truth, then reloads so item lines, discounts and totals are rebuilt.
  const removeCartLine = async (event) => {
    const trigger = event.target.closest('[data-nn-cart-remove]');
    if (!trigger) return;

    const removeButton = trigger.closest('cart-remove-button');
    if (!removeButton) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const key = trigger.dataset.key || removeButton.dataset.key;
    const line = Number(trigger.dataset.index || removeButton.dataset.index);
    if (!key && (!Number.isFinite(line) || line < 1)) return;

    trigger.disabled = true;
    trigger.setAttribute('aria-busy', 'true');

    const requestChange = async (payload) => {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error(`Cart change failed (${response.status})`);
      return response.json();
    };

    try {
      await requestChange(key ? { id: key, quantity: 0 } : { line, quantity: 0 });
      window.location.reload();
    } catch (error) {
      console.error('NicheNova: unable to remove cart item.', error);

      // Line-based retry covers an unusual case where the item key changed
      // between render and click.
      if (Number.isFinite(line) && line > 0) {
        try {
          await requestChange({ line, quantity: 0 });
          window.location.reload();
          return;
        } catch (retryError) {
          console.error('NicheNova: cart remove retry failed.', retryError);
        }
      }

      trigger.disabled = false;
      trigger.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', openCartDrawer);
  document.addEventListener('click', removeCartLine, true);
})();
